/**
 * 保险单
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
import TableContent from './components/OrderTable';
import KeepAlive from '@/routes/KeepAlive';
import model from '@/reducers/order/insuranceorder/model';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        tab: [
            { id: 1, label: '保险单' },
        ],
        curTabID: 1,  // 当前显示的Tab页ID
        paymentItem: {}//支付方式
    };

    componentDidMount() {
        const { setBreadcrumbPaths, getPayTypeEnum } = this.props;
        setBreadcrumbPaths(this.props.match); // 自动识别面包屑
        getPayTypeEnum({ enumName: 'RiderInsurePaymentChannelTypeEnum' });
    }
    // Tab页切换
    _tabChangeHandle = (tabID) => {
        this.setState({
            curTabID: tabID,
        }, () => {
            this._searchHandle('useCache');
        });
    }
    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
            // 详情
            case 'info':
                history.push({
                    pathname: `/home/order/insuranceorder/orderdetail/${record.insurePolicyId}`,
                });
                break;
        }

    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, riderTel, insurePolicyId, riderName, startDate, endDate, paymentItem
        } = this.state;
        const query = {
            riderTel,
            insurePolicyId,
            riderName,
            startDate,
            endDate,
            channelType: paymentItem.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getInsurePolicyList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({
            riderTel: undefined, insurePolicyId: undefined, riderName: undefined, startDate: undefined, endDate: undefined,
            pageNum: 1, pageSize: 10, paymentItem: {}
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }
    startDate = () => {
        this.setState({ createTimeEnd: undefined });
    }
    disabledDate = (current) => {
        const { createTimeStart } = this.state;
        let enddays = createTimeStart && moment(createTimeStart);
        return current && current < enddays && enddays.startOf('day');
    }
    nameHandle = e => {
        var value = e.target.value;
        const reg = /^([\u4e00-\u9fa5]|[a-zA-Z]| |•|-|‧|•|⋅|ㆍ|・|●|(\（+\）)|(\（[\u4e00-\u9fa5]+\）)|(\（[a-zA-Z]+\）))+$/; // 可输入56个汉字及英文字符，除少数民族名字分隔符外，不可输入表情符号或其它符号，
        if (value && value.toString().length > 56) {
            return;
        } else if (!reg.test(value)) {
            this.setState({ riderName: undefined });
        }
    }
    render() {
        const { riderTel, insurePolicyId, riderName, startDate, endDate, paymentItem } = this.state;
        const { InsurePolicyList, payTypeEnum } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                    <div className={styles.orderContainer}>
                        <SearchBox>
                            <SearchItem>
                                <XInputNum
                                    label='手机号码'
                                    placeholder='请输入手机号码'
                                    value={riderTel}
                                    bindThis={this}
                                    bindName='riderTel'
                                    min={0}
                                    precision={0}
                                    maxLength={11}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='姓名'
                                    placeholder='请输入姓名'
                                    value={riderName}
                                    bindThis={this}
                                    bindName='riderName'
                                    onBlur={this.nameHandle}
                                    maxLength={56}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInputNum
                                    label='流水号'
                                    placeholder='请输入流水号'
                                    value={insurePolicyId}
                                    bindThis={this}
                                    bindName='insurePolicyId'
                                    min={0}
                                    precision={0}
                                // maxLength={11}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XDatePicker
                                    label='投保时间'
                                    value={startDate}
                                    bindThis={this}
                                    bindName='startDate'
                                    isFormat
                                    showTime={false}
                                    defaultTime='00:00:00'
                                // onChange={this.startDate}
                                />
                                <div className={styles.timeLine} />
                                <XDatePicker
                                    style={{ marginRight: 20 }}
                                    label=''
                                    value={endDate}
                                    bindThis={this}
                                    bindName='endDate'
                                    isFormat
                                    showTime={false}
                                    defaultTime='23:59:59'
                                // disabledDate={this.disabledDate}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XSelect
                                    label='支付方式'
                                    placeholder='请选择支付方式'
                                    renderData={payTypeEnum}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={paymentItem.value}
                                    bindThis={this}
                                    bindName='paymentItem'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                    </div>
                    <TableContent
                        renderData={InsurePolicyList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
    match: PropTypes.object,
    getInsurePolicyList: PropTypes.func,
    InsurePolicyList: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
    getPayTypeEnum: PropTypes.func,
    payTypeEnum: PropTypes.array
};
const mapStateToProps = (state) => ({
    InsurePolicyList: state.insuranceorder.InsurePolicyList,
    payTypeEnum: state.insuranceorder.payTypeEnum,
});
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);